var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysiciansGrowingPractice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.55,
    height: 90,
    viewBox: "0 0 104.55 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "41.18 35.77 28.17 35.77 28.17 22.76 13.18 22.76 13.18 35.77 0.17 35.77 0.17 50.77 13.18 50.77 13.18 63.78 28.17 63.78 28.17 50.77 41.18 50.77 41.18 35.77",
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.57 36.36 27.58 36.36 27.58 24.38 13.77 24.38 13.77 36.36 1.78 36.36 1.78 50.18 13.77 50.18 13.77 62.16 27.58 62.16 27.58 50.18 39.57 50.18 39.57 36.36",
    fill: "none",
    stroke: "#e4d45a",
    strokeMiterlimit: 10,
    strokeWidth: 0.31
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.95 36.95 26.99 36.95 26.99 25.99 14.36 25.99 14.36 36.95 3.4 36.95 3.4 49.59 14.36 49.59 14.36 60.55 26.99 60.55 26.99 49.59 37.95 49.59 37.95 36.95",
    fill: "none",
    stroke: "#d2c355",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.34 37.54 26.4 37.54 26.4 27.61 14.95 27.61 14.95 37.54 5.01 37.54 5.01 49 14.95 49 14.95 58.93 26.4 58.93 26.4 49 36.34 49 36.34 37.54",
    fill: "none",
    stroke: "#c0b350",
    strokeMiterlimit: 10,
    strokeWidth: 0.28
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.72 38.13 25.81 38.13 25.81 29.22 15.54 29.22 15.54 38.13 6.63 38.13 6.63 48.41 15.54 48.41 15.54 57.32 25.81 57.32 25.81 48.41 34.72 48.41 34.72 38.13",
    fill: "none",
    stroke: "#aea34c",
    strokeMiterlimit: 10,
    strokeWidth: 0.27
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.11 38.72 25.22 38.72 25.22 30.84 16.13 30.84 16.13 38.72 8.24 38.72 8.24 47.82 16.13 47.82 16.13 55.7 25.22 55.7 25.22 47.82 33.11 47.82 33.11 38.72",
    fill: "none",
    stroke: "#9c9247",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.49 39.31 24.63 39.31 24.63 32.45 16.72 32.45 16.72 39.31 9.85 39.31 9.85 47.23 16.72 47.23 16.72 54.09 24.63 54.09 24.63 47.23 31.49 47.23 31.49 39.31",
    fill: "none",
    stroke: "#898242",
    strokeMiterlimit: 10,
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.88 39.91 24.04 39.91 24.04 34.07 17.31 34.07 17.31 39.91 11.47 39.91 11.47 46.63 17.31 46.63 17.31 52.47 24.04 52.47 24.04 46.63 29.88 46.63 29.88 39.91",
    fill: "none",
    stroke: "#77723d",
    strokeMiterlimit: 10,
    strokeWidth: 0.22
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.26 40.49 23.45 40.49 23.45 35.68 17.9 35.68 17.9 40.49 13.08 40.49 13.08 46.05 17.9 46.05 17.9 50.86 23.45 50.86 23.45 46.05 28.26 46.05 28.26 40.49",
    fill: "none",
    stroke: "#656138",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.65 41.09 22.86 41.09 22.86 37.3 18.49 37.3 18.49 41.09 14.7 41.09 14.7 45.45 18.49 45.45 18.49 49.24 22.86 49.24 22.86 45.45 26.65 45.45 26.65 41.09",
    fill: "none",
    stroke: "#535134",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.03 41.68 22.27 41.68 22.27 38.91 19.08 38.91 19.08 41.68 16.31 41.68 16.31 44.86 19.08 44.86 19.08 47.63 22.27 47.63 22.27 44.86 25.03 44.86 25.03 41.68",
    fill: "none",
    stroke: "#41412f",
    strokeMiterlimit: 10,
    strokeWidth: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.42 42.27 21.68 42.27 21.68 40.53 19.67 40.53 19.67 42.27 17.93 42.27 17.93 44.27 19.67 44.27 19.67 46.01 21.68 46.01 21.68 44.27 23.42 44.27 23.42 42.27",
    fill: "none",
    stroke: "#2f302a",
    strokeMiterlimit: 10,
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.8 42.86 21.09 42.86 21.09 42.14 20.26 42.14 20.26 42.86 19.54 42.86 19.54 43.68 20.26 43.68 20.26 44.4 21.09 44.4 21.09 43.68 21.8 43.68 21.8 42.86",
    fill: "none",
    stroke: "#1d2025",
    strokeMiterlimit: 10,
    strokeWidth: 0.14
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.33 52.9 87.2 52.9 87.2 35.77 67.45 35.77 67.45 52.9 50.32 52.9 50.32 72.65 67.45 72.65 67.45 89.78 87.2 89.78 87.2 72.65 104.33 72.65 104.33 52.9",
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.2 53.68 86.42 53.68 86.42 37.9 68.23 37.9 68.23 53.68 52.45 53.68 52.45 71.87 68.23 71.87 68.23 87.66 86.42 87.66 86.42 71.87 102.2 71.87 102.2 53.68",
    fill: "none",
    stroke: "#e4d45a",
    strokeMiterlimit: 10,
    strokeWidth: 0.41
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.08 54.46 85.64 54.46 85.64 40.02 69.01 40.02 69.01 54.46 54.57 54.46 54.57 71.09 69.01 71.09 69.01 85.53 85.64 85.53 85.64 71.09 100.08 71.09 100.08 54.46",
    fill: "none",
    stroke: "#d2c355",
    strokeMiterlimit: 10,
    strokeWidth: 0.39
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.95 55.23 84.87 55.23 84.87 42.15 69.78 42.15 69.78 55.23 56.7 55.23 56.7 70.32 69.78 70.32 69.78 83.4 84.87 83.4 84.87 70.32 97.95 70.32 97.95 55.23",
    fill: "none",
    stroke: "#c0b350",
    strokeMiterlimit: 10,
    strokeWidth: 0.37
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.82 56.01 84.09 56.01 84.09 44.28 70.56 44.28 70.56 56.01 58.83 56.01 58.83 69.54 70.56 69.54 70.56 81.28 84.09 81.28 84.09 69.54 95.82 69.54 95.82 56.01",
    fill: "none",
    stroke: "#aea34c",
    strokeMiterlimit: 10,
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.7 56.79 83.31 56.79 83.31 46.4 71.34 46.4 71.34 56.79 60.95 56.79 60.95 68.76 71.34 68.76 71.34 79.15 83.31 79.15 83.31 68.76 93.7 68.76 93.7 56.79",
    fill: "none",
    stroke: "#9c9247",
    strokeMiterlimit: 10,
    strokeWidth: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.57 57.57 82.53 57.57 82.53 48.53 72.12 48.53 72.12 57.57 63.08 57.57 63.08 67.98 72.12 67.98 72.12 77.02 82.53 77.02 82.53 67.98 91.57 67.98 91.57 57.57",
    fill: "none",
    stroke: "#898242",
    strokeMiterlimit: 10,
    strokeWidth: 0.31
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.44 58.34 81.76 58.34 81.76 50.66 72.89 50.66 72.89 58.34 65.21 58.34 65.21 67.21 72.89 67.21 72.89 74.9 81.76 74.9 81.76 67.21 89.44 67.21 89.44 58.34",
    fill: "none",
    stroke: "#77723d",
    strokeMiterlimit: 10,
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.32 59.12 80.98 59.12 80.98 52.78 73.67 52.78 73.67 59.12 67.33 59.12 67.33 66.43 73.67 66.43 73.67 72.77 80.98 72.77 80.98 66.43 87.32 66.43 87.32 59.12",
    fill: "none",
    stroke: "#656138",
    strokeMiterlimit: 10,
    strokeWidth: 0.27
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.19 59.9 80.2 59.9 80.2 54.91 74.45 54.91 74.45 59.9 69.46 59.9 69.46 65.65 74.45 65.65 74.45 70.64 80.2 70.64 80.2 65.65 85.19 65.65 85.19 59.9",
    fill: "none",
    stroke: "#535134",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.06 60.68 79.42 60.68 79.42 57.04 75.23 57.04 75.23 60.68 71.59 60.68 71.59 64.88 75.23 64.88 75.23 68.52 79.42 68.52 79.42 64.88 83.06 64.88 83.06 60.68",
    fill: "none",
    stroke: "#41412f",
    strokeMiterlimit: 10,
    strokeWidth: 0.23
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.94 61.45 78.65 61.45 78.65 59.16 76 59.16 76 61.45 73.71 61.45 73.71 64.1 76 64.1 76 66.39 78.65 66.39 78.65 64.1 80.94 64.1 80.94 61.45",
    fill: "none",
    stroke: "#2f302a",
    strokeMiterlimit: 10,
    strokeWidth: 0.21
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.81 62.23 77.87 62.23 77.87 61.29 76.78 61.29 76.78 62.23 75.84 62.23 75.84 63.32 76.78 63.32 76.78 64.26 77.87 64.26 77.87 63.32 78.81 63.32 78.81 62.23",
    fill: "none",
    stroke: "#1d2025",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.44 9 56.55 9 56.55 0.11 46.31 0.11 46.31 9 37.43 9 37.43 19.24 46.31 19.24 46.31 28.12 56.55 28.12 56.55 19.24 65.44 19.24 65.44 9",
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.23
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.33 9.4 56.15 9.4 56.15 1.22 46.72 1.22 46.72 9.4 38.53 9.4 38.53 18.83 46.72 18.83 46.72 27.02 56.15 27.02 56.15 18.83 64.33 18.83 64.33 9.4",
    fill: "none",
    stroke: "#e4d45a",
    strokeMiterlimit: 10,
    strokeWidth: 0.21
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.23 9.8 55.74 9.8 55.74 2.32 47.12 2.32 47.12 9.8 39.63 9.8 39.63 18.43 47.12 18.43 47.12 25.91 55.74 25.91 55.74 18.43 63.23 18.43 63.23 9.8",
    fill: "none",
    stroke: "#d2c355",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.13 10.21 55.34 10.21 55.34 3.42 47.52 3.42 47.52 10.21 40.74 10.21 40.74 18.03 47.52 18.03 47.52 24.81 55.34 24.81 55.34 18.03 62.13 18.03 62.13 10.21",
    fill: "none",
    stroke: "#c0b350",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.02 10.61 54.94 10.61 54.94 4.52 47.92 4.52 47.92 10.61 41.84 10.61 41.84 17.62 47.92 17.62 47.92 23.71 54.94 23.71 54.94 17.62 61.02 17.62 61.02 10.61",
    fill: "none",
    stroke: "#aea34c",
    strokeMiterlimit: 10,
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.92 11.01 54.54 11.01 54.54 5.63 48.33 5.63 48.33 11.01 42.94 11.01 42.94 17.22 48.33 17.22 48.33 22.61 54.54 22.61 54.54 17.22 59.92 17.22 59.92 11.01",
    fill: "none",
    stroke: "#9c9247",
    strokeMiterlimit: 10,
    strokeWidth: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.82 11.41 54.13 11.41 54.13 6.73 48.73 6.73 48.73 11.41 44.04 11.41 44.04 16.82 48.73 16.82 48.73 21.5 54.13 21.5 54.13 16.82 58.82 16.82 58.82 11.41",
    fill: "none",
    stroke: "#898242",
    strokeMiterlimit: 10,
    strokeWidth: 0.16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.72 11.82 53.73 11.82 53.73 7.83 49.13 7.83 49.13 11.82 45.15 11.82 45.15 16.41 49.13 16.41 49.13 20.4 53.73 20.4 53.73 16.41 57.72 16.41 57.72 11.82",
    fill: "none",
    stroke: "#77723d",
    strokeMiterlimit: 10,
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.61 12.22 53.33 12.22 53.33 8.93 49.54 8.93 49.54 12.22 46.25 12.22 46.25 16.01 49.54 16.01 49.54 19.3 53.33 19.3 53.33 16.01 56.61 16.01 56.61 12.22",
    fill: "none",
    stroke: "#656138",
    strokeMiterlimit: 10,
    strokeWidth: 0.14
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.51 12.63 52.92 12.63 52.92 10.04 49.94 10.04 49.94 12.63 47.35 12.63 47.35 15.61 49.94 15.61 49.94 18.2 52.92 18.2 52.92 15.61 55.51 15.61 55.51 12.63",
    fill: "none",
    stroke: "#535134",
    strokeMiterlimit: 10,
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.41 13.03 52.52 13.03 52.52 11.14 50.34 11.14 50.34 13.03 48.45 13.03 48.45 15.2 50.34 15.2 50.34 17.09 52.52 17.09 52.52 15.2 54.41 15.2 54.41 13.03",
    fill: "none",
    stroke: "#41412f",
    strokeMiterlimit: 10,
    strokeWidth: 0.12
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.3 13.43 52.12 13.43 52.12 12.24 50.75 12.24 50.75 13.43 49.56 13.43 49.56 14.8 50.75 14.8 50.75 15.99 52.12 15.99 52.12 14.8 53.3 14.8 53.3 13.43",
    fill: "none",
    stroke: "#2f302a",
    strokeMiterlimit: 10,
    strokeWidth: 0.11
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.2 13.83 51.71 13.83 51.71 13.35 51.15 13.35 51.15 13.83 50.66 13.83 50.66 14.4 51.15 14.4 51.15 14.89 51.71 14.89 51.71 14.4 52.2 14.4 52.2 13.83",
    fill: "none",
    stroke: "#1d2025",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiciansGrowingPractice);
export default __webpack_public_path__ + "static/media/physiciansGrowingPractice.87559e333e37a7a0446ef23dea07c32d.svg";
export { ForwardRef as ReactComponent };